import dynamic from 'next/dynamic';

const HomeIcon = dynamic(() => import('./HomeIcon'));
const SalesIcon = dynamic(() => import('./SalesIcon'));
const FleetIcon = dynamic(() => import('./FleetIcon'));
const SellVehiclesIcon = dynamic(() => import('./SellVehiclesIcon'));
const LeasingIcon = dynamic(() => import('./LeasingIcon'));
const ArmIcon = dynamic(() => import('./ArmIcon'));
const LogisticsIcon = dynamic(() => import('./LogisticsIcon'));
const BillingIcon = dynamic(() => import('./BillingIcon'));
const ServicesIcon = dynamic(() => import('./ServicesIcon'));
const ProductsIcon = dynamic(() => import('./ProductsIcon'));
const CatalogIcon = dynamic(() => import('./CatalogIcon'));
const MarketplaceIcon = dynamic(() => import('./MarketplaceIcon'));
const DriverseIcon = dynamic(() => import('./DriverseIcon'));
const CRMIcon = dynamic(() => import('./CRMIcon'));
const DriversIcon = dynamic(() => import('./DriversIcon'));
const UnifiedViewIcon = dynamic(() => import('./UnifiedViewIcon'));
const ReportsIcon = dynamic(() => import('./ReportsIcon'));
const UtilitiesIcon = dynamic(() => import('./UtilitiesIcon'));
const AdminIcon = dynamic(() => import('./AdminIcon'));
const VisualsIcon = dynamic(() => import('./VisualsIcon'));
const CreditCheckIcon = dynamic(() => import('./CreditCheckIcon'));

export {
  HomeIcon,
  SalesIcon,
  FleetIcon,
  SellVehiclesIcon,
  LeasingIcon,
  ArmIcon,
  LogisticsIcon,
  BillingIcon,
  ServicesIcon,
  ProductsIcon,
  CatalogIcon,
  MarketplaceIcon,
  DriverseIcon,
  CRMIcon,
  DriversIcon,
  UnifiedViewIcon,
  ReportsIcon,
  UtilitiesIcon,
  AdminIcon,
  VisualsIcon,
  CreditCheckIcon,
};
